import { FORM_TEMPLATES } from '../../../constants/templates';

export const isTemplateForm = (formId: string) =>
  Object.values(FORM_TEMPLATES).includes(formId);
